export default __webpack_public_path__ + "static/media/226.889e596b.jpg";